<script setup lang="ts">
import { Page, Section } from "@/components/Ui";
import { HeroWorldwide } from "@/components/Hero";
import {
  BlockAppleGooglePay,
  BlockCardsUsAndEu,
  BlockConvenientTopUp,
  BlockCurrencyRate,
  BlockInstantIssuance,
  BlockNeedPlasticCard,
  BlockTDS,
  BlockTeamWork,
  BlockUnlimitedCards,
} from "@/components/Blocks";
import { onEvent } from "@/helpers/events";
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

onMounted(() => {
  onEvent("worldwide page viewed", null, {
    "product name": "worldwide"
  });
});

useSeoMeta({
  title: t("page.worldwide.seo.title"),
  description: t("page.worldwide.seo.description"),
  ogTitle: t("page.worldwide.seo.title"),
  ogDescription: t("page.worldwide.seo.description")
});
</script>
<template>
  <Page :class="$style.root">
    <HeroWorldwide />
    <Section
      :title-class="$style.section__title"
      :class="$style.section"
      container
    >
      <div :class="$style[`section-wrapper`]">
        <BlockCardsUsAndEu />
        <BlockCurrencyRate />
        <BlockUnlimitedCards />
      </div>
    </Section>
    <Section
      :title-class="$style.section__title"
      :class="$style.section"
      container
    >
      <template #title>
        {{ $t("page.wordwide.section2.title") }}
      </template>
      <div :class="`${$style[`section-wrapper2`]}`">
        <BlockAppleGooglePay />
        <BlockTDS />
        <BlockNeedPlasticCard />
      </div>
    </Section>
    <Section
      :title-class="$style.section__title"
      :class="$style.section"
      container
    >
      <template #title>
        {{ $t("page.wordwide.section3.title") }}
      </template>
      <div :class="`${$style[`section-wrapper2`]}`">
        <BlockInstantIssuance />
        <BlockConvenientTopUp />
        <BlockTeamWork />
      </div>
    </Section>
  </Page>
</template>
<style lang="scss" module>
.root {
  @apply flex flex-col gap-[86px] lg:gap-[136px] pb-[80px] mt-[70px] md:mt-[90px];
}

.section {
  @apply w-full;
  &__title {
    @apply text-center px-4 font-light text-[40px] sm:text-[52px] leading-[123%];
  }
  &-wrapper {
    @apply w-full grid grid-cols-1 gap-5;
    @apply md:grid-cols-2;

    & > div {
      &:first-child {
        @apply md:col-span-2;
      }
    }
  }

  &-wrapper2 {
    @apply w-full grid grid-cols-1 gap-5;
    @apply md:grid-cols-2;

    & > div {
      @apply col-span-1;
      &:last-child {
        @apply md:col-span-2;
      }
    }
  }
}
</style>
